/**
 * Admin menu items only. Safe to import from Client Components (e.g. AdminSidebar).
 * Do not import page components here to avoid pulling server-only code into client bundle.
 */
import type { AdminMenuItem } from '../../config/shell-config'

/** Full list of admin menu items when config.admin.primaryItems is not set */
export const FULL_ADMIN_MENU_ITEMS: AdminMenuItem[] = [
  { id: 'users', label: 'Users', href: '/admin/users', icon: 'ri-user-line', description: 'Manage users' },
  { id: 'settings', label: 'Settings', href: '/admin/settings', icon: 'ri-settings-3-line', description: 'System configuration' },
  { id: 'monitoring', label: 'Monitoring', href: '/admin/monitoring', icon: 'ri-dashboard-line', description: 'System monitoring' },
  { id: 'activity', label: 'Activity', href: '/admin/activity', icon: 'ri-time-line', description: 'Activity log' },
  { id: 'audit', label: 'Audit', href: '/admin/audit', icon: 'ri-file-list-3-line', description: 'Audit logs' },
  { id: 'rate-limiting', label: 'Rate Limiting', href: '/admin/rate-limiting', icon: 'ri-speed-line', description: 'Rate limits' },
  { id: 'registration-codes', label: 'Registration Codes', href: '/admin/registration-codes', icon: 'ri-key-line', description: 'Create and print codes' },
  { id: 'transcripts', label: 'Transcripts', href: '/admin/transcripts', icon: 'ri-chat-3-line', description: 'Chat transcripts' },
  { id: 'auth-settings', label: 'Auth Settings', href: '/admin/auth-settings', icon: 'ri-shield-keyhole-line', description: 'Auth configuration' },
  { id: 'tools-create', label: 'Create Tool', href: '/admin/tools/create', icon: 'ri-tools-line', description: 'Create custom tool' },
]

export function getShellAdminMenuItems(): AdminMenuItem[] {
  return [...FULL_ADMIN_MENU_ITEMS]
}
